import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef } from 'react';
import { MarkerSeries } from './marker-series';
import { lineSeriesOptions, markerSeriesOptions } from './options';
import { useChartColors } from './hooks/use-chart-colors';
import { chartManager } from './manager';
import { getLeftYAxisOptions, getRightYAxisOptions } from './utils';
import { SteppedMarkersLineSeries } from './stepped-markers-line-series/series';
export const Chart = ({ data, selectedSeries, secondaryAssetCode, hideUsdSeries = false, onSeriesLineSelected, }) => {
    /**
     * Vars
     */
    const ref = useRef(null);
    /**
     * Hooks
     */
    const chartColors = useChartColors(selectedSeries);
    useLayoutEffect(() => {
        if (!ref || !ref.current) {
            return;
        }
        chartManager.setDataAndSeries(data, secondaryAssetCode, selectedSeries);
        chartManager.setContainer(ref.current);
        chartManager.setOnSeriesLineSelected(onSeriesLineSelected);
        return () => chartManager.flush();
    }, []);
    useEffect(() => {
        const chart = chartManager.getChart();
        if (!chart || !data) {
            return;
        }
        if (hideUsdSeries) {
            chart.applyOptions({
                leftPriceScale: {
                    visible: false,
                },
            });
        }
        chartManager.createSeries('lineAssetSeries', () => {
            const opts = getLeftYAxisOptions(lineSeriesOptions, chartColors.assetAmount, secondaryAssetCode);
            return chart.addCustomSeries(new SteppedMarkersLineSeries(), Object.assign(Object.assign({}, opts), { priceScaleId: hideUsdSeries ? undefined : opts.priceScaleId, id: `lineAssetSeries` }));
        });
        if (!hideUsdSeries) {
            chartManager.createSeries('lineUsdSeries', () => {
                const opts = getRightYAxisOptions(lineSeriesOptions, chartColors.usdValue);
                return chart.addCustomSeries(new SteppedMarkersLineSeries(), Object.assign(Object.assign({}, opts), { id: `lineUsdSeries` }));
            });
        }
        chartManager.createSeries('markerAssetSeries', () => {
            const opts = getLeftYAxisOptions(markerSeriesOptions, chartColors.assetAmount, secondaryAssetCode);
            return chart.addCustomSeries(new MarkerSeries(), Object.assign(Object.assign({}, opts), { priceScaleId: hideUsdSeries ? undefined : opts.priceScaleId }));
        });
        if (!hideUsdSeries) {
            chartManager.createSeries('markerUsdSeries', () => {
                return chart.addCustomSeries(new MarkerSeries(), getRightYAxisOptions(markerSeriesOptions, chartColors.usdValue));
            });
        }
        chartManager.reDraw(data, secondaryAssetCode, selectedSeries, chartColors);
    }, []);
    useEffect(() => {
        chartManager.reDraw(data, secondaryAssetCode, selectedSeries, chartColors);
    }, [data, selectedSeries, chartColors]);
    /**
     * DOM
     */
    return (_jsx("div", { ref: ref, style: {
            width: `100%`,
            position: `relative`,
            zIndex: 1,
        } }));
};
